<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'MaDeviceInput',
})
</script>
<template>
	<el-input v-model="userName" :clearable :disabled :placeholder @clear="model = ''">
		<template #append>
			<el-button icon="Search" @click="visible = true" />
		</template>
	</el-input>
	<ma-device-dialog
		v-if="!disabled && visible"
		:key="visible"
		v-model="visible"
		:multiple
		:default-selected="getCurrentSelectedIds()"
		@select="userHandle"
	>
	</ma-device-dialog>
</template>

<script setup lang="ts" name="MaDeviceInput">
import { ref, watch } from 'vue'

import { apiRequest } from '@/api/common'
const props = defineProps({
	multiple: {
		type: Boolean,
		required: false,
		default: false
	},
	clearable: {
		type: Boolean,
		required: false,
		default: () => true
	},
	disabled: {
		type: Boolean,
		required: false,
		default: () => false
	},
	placeholder: {
		type: String,
		required: false,
		default: () => ''
	}
})

const model = defineModel<any | any[]>()
const visible = ref(false)
const userName = ref()

watch(
	() => model.value,
	async val => {
		if (val) {
			if (props.multiple && typeof val === 'string') {
				val = val.split(',')
			}
			const idList = val
			if (idList.length > 0) {
				apiRequest('POST', '/maku/biz_device/deviceNameList', props.multiple ? idList : [idList]).then(res => {
					userName.value = res.data.join(',')
				})
			}
		} else {
			userName.value = ''
		}
	},
	{
		immediate: true
	}
)

// 获取当前已选设备ID列表
const getCurrentSelectedIds = () => {
	if (!model.value) {
		return []
	}
	if (props.multiple) {
		if (Array.isArray(model.value)) {
			return model.value
		}
		if (typeof model.value === 'string') {
			return model.value.split(',').filter(id => id.trim())
		}
	}
	return [model.value]
}

const emit = defineEmits(['select', 'change'])
const userHandle = (rows: any[]) => {
	if (props.multiple) {
		model.value = rows.map((item: any) => item.id)
	} else {
		model.value = rows[0].id
	}
	emit('select', rows)
	emit('change', rows)
}
</script>
